import * as Sentry from "@sentry/nextjs";

/**
 * Capture an exception to Sentry, but only in production.
 * Errors are always logged to console in all environments.
 *
 * Note: enableSentryInDev flag is checked in the Sentry init configs
 * (sentry.server.config.ts, etc.), so if Sentry is initialized, this will send.
 *
 * @returns Event ID if sent to Sentry, undefined if skipped
 */
export function captureException(
  ...args: Parameters<typeof Sentry.captureException>
): ReturnType<typeof Sentry.captureException> | undefined {
  const [exception, hint] = args;

  // Always log to console in all environments
  console.error("[Sentry]", exception, hint);

  // Send to Sentry if it's initialized (production or dev with flag enabled)
  // Sentry.captureException is a no-op if Sentry.init() wasn't called
  return Sentry.captureException(...args);
}
